// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { AssetInfoFragmentDoc } from '../../projects/assets/AssetPreview.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type MilestoneCatalogFormQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type MilestoneCatalogFormQuery = { __typename?: 'Query', globalPlanMilestone: { __typename?: 'GlobalPlanMilestone', id: string, name: string, isDefault: boolean, description?: string | null | undefined, isHomeownerVisible: boolean, homeownerName?: string | null | undefined, homeownerDescription?: string | null | undefined, groups: Array<{ __typename?: 'GlobalPlanMilestoneGroup', id: string, name: string, businessFunctionType: { __typename?: 'BusinessFunctionTypeDetail', code: Types.BusinessFunctionType, name: string } }>, constraints: Array<{ __typename?: 'GlobalPlanConstraintItem', id: string, name: string }>, systemPlanMilestone?: { __typename?: 'SystemPlanMilestoneDetail', code: Types.SystemPlanMilestone, name: string } | null | undefined, homeownerIcon?: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } | null | undefined } };

export type MilestoneCatalogFormDropdownQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MilestoneCatalogFormDropdownQuery = { __typename?: 'Query', globalPlanMilestoneGroups: Array<{ __typename?: 'GlobalPlanMilestoneGroup', id: string, name: string, businessFunctionType: { __typename?: 'BusinessFunctionTypeDetail', code: Types.BusinessFunctionType, name: string } }>, globalPlanConstraintItems: Array<{ __typename?: 'GlobalPlanConstraintItem', id: string, name: string }> };

export type SaveGlobalPlanMilestonesMutationVariables = Types.Exact<{
  input: Types.SaveGlobalPlanMilestonesInput;
}>;


export type SaveGlobalPlanMilestonesMutation = { __typename?: 'Mutation', saveGlobalPlanMilestones: { __typename?: 'SaveGlobalPlanMilestonesResult', globalPlanMilestones: Array<{ __typename?: 'GlobalPlanMilestone', id: string }> } };

export type MilestoneCatalogForm_GlobalPlanMilestoneFragment = { __typename?: 'GlobalPlanMilestone', id: string, name: string, isDefault: boolean, description?: string | null | undefined, isHomeownerVisible: boolean, homeownerName?: string | null | undefined, homeownerDescription?: string | null | undefined, groups: Array<{ __typename?: 'GlobalPlanMilestoneGroup', id: string, name: string, businessFunctionType: { __typename?: 'BusinessFunctionTypeDetail', code: Types.BusinessFunctionType, name: string } }>, constraints: Array<{ __typename?: 'GlobalPlanConstraintItem', id: string, name: string }>, systemPlanMilestone?: { __typename?: 'SystemPlanMilestoneDetail', code: Types.SystemPlanMilestone, name: string } | null | undefined, homeownerIcon?: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } | null | undefined };

export type MilestoneCatalogForm_GlobalPlanMilestoneGroupFragment = { __typename?: 'GlobalPlanMilestoneGroup', id: string, name: string, businessFunctionType: { __typename?: 'BusinessFunctionTypeDetail', code: Types.BusinessFunctionType, name: string } };

export const MilestoneCatalogForm_GlobalPlanMilestoneGroupFragmentDoc = gql`
    fragment MilestoneCatalogForm_GlobalPlanMilestoneGroup on GlobalPlanMilestoneGroup {
  id
  name
  businessFunctionType {
    code
    name
  }
}
    `;
export const MilestoneCatalogForm_GlobalPlanMilestoneFragmentDoc = gql`
    fragment MilestoneCatalogForm_GlobalPlanMilestone on GlobalPlanMilestone {
  id
  name
  isDefault
  description
  isHomeownerVisible
  groups {
    ...MilestoneCatalogForm_GlobalPlanMilestoneGroup
  }
  constraints {
    id
    name
  }
  systemPlanMilestone {
    code
    name
  }
  homeownerName
  homeownerDescription
  homeownerIcon {
    ...AssetInfo
  }
}
    ${MilestoneCatalogForm_GlobalPlanMilestoneGroupFragmentDoc}
${AssetInfoFragmentDoc}`;
export const MilestoneCatalogFormDocument = gql`
    query MilestoneCatalogForm($id: ID!) {
  globalPlanMilestone(id: $id) {
    ...MilestoneCatalogForm_GlobalPlanMilestone
  }
}
    ${MilestoneCatalogForm_GlobalPlanMilestoneFragmentDoc}`;

/**
 * __useMilestoneCatalogFormQuery__
 *
 * To run a query within a React component, call `useMilestoneCatalogFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useMilestoneCatalogFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMilestoneCatalogFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMilestoneCatalogFormQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MilestoneCatalogFormQuery, MilestoneCatalogFormQueryVariables> & ({ variables: MilestoneCatalogFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MilestoneCatalogFormQuery, MilestoneCatalogFormQueryVariables>(MilestoneCatalogFormDocument, options);
      }
export function useMilestoneCatalogFormLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MilestoneCatalogFormQuery, MilestoneCatalogFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MilestoneCatalogFormQuery, MilestoneCatalogFormQueryVariables>(MilestoneCatalogFormDocument, options);
        }
export function useMilestoneCatalogFormSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MilestoneCatalogFormQuery, MilestoneCatalogFormQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MilestoneCatalogFormQuery, MilestoneCatalogFormQueryVariables>(MilestoneCatalogFormDocument, options);
        }
export type MilestoneCatalogFormQueryHookResult = ReturnType<typeof useMilestoneCatalogFormQuery>;
export type MilestoneCatalogFormLazyQueryHookResult = ReturnType<typeof useMilestoneCatalogFormLazyQuery>;
export type MilestoneCatalogFormSuspenseQueryHookResult = ReturnType<typeof useMilestoneCatalogFormSuspenseQuery>;
export type MilestoneCatalogFormQueryResult = Apollo.QueryResult<MilestoneCatalogFormQuery, MilestoneCatalogFormQueryVariables>;
export const MilestoneCatalogFormDropdownDocument = gql`
    query MilestoneCatalogFormDropdown {
  globalPlanMilestoneGroups {
    ...MilestoneCatalogForm_GlobalPlanMilestoneGroup
  }
  globalPlanConstraintItems {
    id
    name
  }
}
    ${MilestoneCatalogForm_GlobalPlanMilestoneGroupFragmentDoc}`;

/**
 * __useMilestoneCatalogFormDropdownQuery__
 *
 * To run a query within a React component, call `useMilestoneCatalogFormDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useMilestoneCatalogFormDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMilestoneCatalogFormDropdownQuery({
 *   variables: {
 *   },
 * });
 */
export function useMilestoneCatalogFormDropdownQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MilestoneCatalogFormDropdownQuery, MilestoneCatalogFormDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MilestoneCatalogFormDropdownQuery, MilestoneCatalogFormDropdownQueryVariables>(MilestoneCatalogFormDropdownDocument, options);
      }
export function useMilestoneCatalogFormDropdownLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MilestoneCatalogFormDropdownQuery, MilestoneCatalogFormDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MilestoneCatalogFormDropdownQuery, MilestoneCatalogFormDropdownQueryVariables>(MilestoneCatalogFormDropdownDocument, options);
        }
export function useMilestoneCatalogFormDropdownSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MilestoneCatalogFormDropdownQuery, MilestoneCatalogFormDropdownQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MilestoneCatalogFormDropdownQuery, MilestoneCatalogFormDropdownQueryVariables>(MilestoneCatalogFormDropdownDocument, options);
        }
export type MilestoneCatalogFormDropdownQueryHookResult = ReturnType<typeof useMilestoneCatalogFormDropdownQuery>;
export type MilestoneCatalogFormDropdownLazyQueryHookResult = ReturnType<typeof useMilestoneCatalogFormDropdownLazyQuery>;
export type MilestoneCatalogFormDropdownSuspenseQueryHookResult = ReturnType<typeof useMilestoneCatalogFormDropdownSuspenseQuery>;
export type MilestoneCatalogFormDropdownQueryResult = Apollo.QueryResult<MilestoneCatalogFormDropdownQuery, MilestoneCatalogFormDropdownQueryVariables>;
export const SaveGlobalPlanMilestonesDocument = gql`
    mutation SaveGlobalPlanMilestones($input: SaveGlobalPlanMilestonesInput!) {
  saveGlobalPlanMilestones(input: $input) {
    globalPlanMilestones {
      id
    }
  }
}
    `;
export type SaveGlobalPlanMilestonesMutationFn = Apollo.MutationFunction<SaveGlobalPlanMilestonesMutation, SaveGlobalPlanMilestonesMutationVariables>;

/**
 * __useSaveGlobalPlanMilestonesMutation__
 *
 * To run a mutation, you first call `useSaveGlobalPlanMilestonesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGlobalPlanMilestonesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGlobalPlanMilestonesMutation, { data, loading, error }] = useSaveGlobalPlanMilestonesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveGlobalPlanMilestonesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveGlobalPlanMilestonesMutation, SaveGlobalPlanMilestonesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveGlobalPlanMilestonesMutation, SaveGlobalPlanMilestonesMutationVariables>(SaveGlobalPlanMilestonesDocument, options);
      }
export type SaveGlobalPlanMilestonesMutationHookResult = ReturnType<typeof useSaveGlobalPlanMilestonesMutation>;
export type SaveGlobalPlanMilestonesMutationResult = Apollo.MutationResult<SaveGlobalPlanMilestonesMutation>;
export type SaveGlobalPlanMilestonesMutationOptions = Apollo.BaseMutationOptions<SaveGlobalPlanMilestonesMutation, SaveGlobalPlanMilestonesMutationVariables>;